import React from 'react';
import { Box, Typography, TextField, Grid } from '@mui/material';
import { formatDisplayAmount } from '../functions/format_display_amount.function';

const POSection = ({ formData, onInputChange, poVerificationData }) => {
  console.log('poVerificationData', poVerificationData);
  const claimedAmount =
    formData?.totalClaimedAmount ?? poVerificationData?.response?.totalCoveredAmount ?? 0;
  return (
    <Box sx={{ mb: 4 }}>
      <Typography
        sx={{
          fontSize: '18px',
          fontFamily: 'Inter',
          fontWeight: 600,
          mb: 2,
          display: 'flex',
        }}
      >
        PO
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            label="Vendor"
            placeholder="..."
            value={formData.vendor}
            onChange={(e) => onInputChange('po', 'vendor', e.target.value)}
            size="small"
            disabled
            sx={{
              '& .MuiOutlinedInput-root': {
                backgroundColor: 'transparent',
                '&.Mui-disabled': {
                  backgroundColor: 'transparent',
                  '& fieldset': {
                    borderColor: 'rgba(0, 0, 0, 0.23)',
                  },
                  '&:hover fieldset': {
                    borderColor: 'rgba(0, 0, 0, 0.23)',
                  },
                },
              },
              '& .MuiInputBase-input.Mui-disabled': {
                WebkitTextFillColor: 'rgba(0, 0, 0, 0.87)',
                color: 'rgba(0, 0, 0, 0.87)',
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            label="Number"
            placeholder="..."
            value={formData.poNumber}
            onChange={(e) => onInputChange('po', 'poNumber', e.target.value)}
            size="small"
            disabled
            sx={{
              '& .MuiOutlinedInput-root': {
                backgroundColor: 'transparent',
                '&.Mui-disabled': {
                  backgroundColor: 'transparent',
                  '& fieldset': {
                    borderColor: 'rgba(0, 0, 0, 0.23)',
                  },
                  '&:hover fieldset': {
                    borderColor: 'rgba(0, 0, 0, 0.23)',
                  },
                },
              },
              '& .MuiInputBase-input.Mui-disabled': {
                WebkitTextFillColor: 'rgba(0, 0, 0, 0.87)',
                color: 'rgba(0, 0, 0, 0.87)',
              },
            }}
          />
        </Grid>
        {'poType' in (formData || {}) && (
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              label="Type"
              placeholder="..."
              value={formData.poType || ''}
              size="small"
              disabled
              sx={{
                '& .MuiOutlinedInput-root': {
                  backgroundColor: 'transparent',
                  '&.Mui-disabled': {
                    backgroundColor: 'transparent',
                    '& fieldset': {
                      borderColor: 'rgba(0, 0, 0, 0.23)',
                    },
                    '&:hover fieldset': {
                      borderColor: 'rgba(0, 0, 0, 0.23)',
                    },
                  },
                },
                '& .MuiInputBase-input.Mui-disabled': {
                  WebkitTextFillColor: 'rgba(0, 0, 0, 0.87)',
                  color: 'rgba(0, 0, 0, 0.87)',
                },
              }}
            />
          </Grid>
        )}
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            label="Amount"
            placeholder="..."
            value={formatDisplayAmount(formData.poAmount)}
            onChange={(e) => onInputChange('po', 'poAmount', e.target.value)}
            size="small"
            disabled
            sx={{
              '& .MuiOutlinedInput-root': {
                backgroundColor: 'transparent',
                '&.Mui-disabled': {
                  backgroundColor: 'transparent',
                  '& fieldset': {
                    borderColor: 'rgba(0, 0, 0, 0.23)',
                  },
                  '&:hover fieldset': {
                    borderColor: 'rgba(0, 0, 0, 0.23)',
                  },
                },
              },
              '& .MuiInputBase-input.Mui-disabled': {
                WebkitTextFillColor: 'rgba(0, 0, 0, 0.87)',
                color: 'rgba(0, 0, 0, 0.87)',
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            label="PO Issuance Date"
            placeholder="..."
            value={formData.poDate}
            onChange={(e) => onInputChange('po', 'poDate', e.target.value)}
            size="small"
            disabled
            sx={{
              '& .MuiOutlinedInput-root': {
                backgroundColor: 'transparent',
                '&.Mui-disabled': {
                  backgroundColor: 'transparent',
                  '& fieldset': {
                    borderColor: 'rgba(0, 0, 0, 0.23)',
                  },
                  '&:hover fieldset': {
                    borderColor: 'rgba(0, 0, 0, 0.23)',
                  },
                },
              },
              '& .MuiInputBase-input.Mui-disabled': {
                WebkitTextFillColor: 'rgba(0, 0, 0, 0.87)',
                color: 'rgba(0, 0, 0, 0.87)',
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            label="PO Delivery Date"
            placeholder="..."
            value={formData.deliverDate}
            onChange={(e) => onInputChange('po', 'deliverDate', e.target.value)}
            size="small"
            disabled
            sx={{
              '& .MuiOutlinedInput-root': {
                backgroundColor: 'transparent',
                '&.Mui-disabled': {
                  backgroundColor: 'transparent',
                  '& fieldset': {
                    borderColor: 'rgba(0, 0, 0, 0.23)',
                  },
                  '&:hover fieldset': {
                    borderColor: 'rgba(0, 0, 0, 0.23)',
                  },
                },
              },
              '& .MuiInputBase-input.Mui-disabled': {
                WebkitTextFillColor: 'rgba(0, 0, 0, 0.87)',
                color: 'rgba(0, 0, 0, 0.87)',
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            label="Total Amount Claimed"
            value={formatDisplayAmount(claimedAmount || 0)}
            onChange={(e) => onInputChange('po', 'totalClaimedAmount', e.target.value)}
            size="small"
            disabled
            sx={{
              '& .MuiOutlinedInput-root': {
                backgroundColor: 'transparent',
                '&.Mui-disabled': {
                  backgroundColor: 'transparent',
                  '& fieldset': {
                    borderColor: 'rgba(0, 0, 0, 0.23)',
                  },
                  '&:hover fieldset': {
                    borderColor: 'rgba(0, 0, 0, 0.23)',
                  },
                },
              },
              '& .MuiInputBase-input.Mui-disabled': {
                WebkitTextFillColor: 'rgba(0, 0, 0, 0.87)',
                color: 'rgba(0, 0, 0, 0.87)',
              },
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default POSection;
